/**
 * Redux container for AgentScannersView component
 *
 * This container connects the AgentScannersView presentational component to the Redux store
 * using React-Redux's connect() HOC with a custom RootStoreContext.
 *
 * @see AgentScannersView for the presentational component
 */
import { connect } from 'react-redux';
import RootStoreContext from '~/contexts/RootStoreContext';
import { actions as modalActions } from '~/domains/modal';
import {
  selectors as agentScannersSelectors,
  actions as agentScannersActions
} from '~/domains/agentScanners';
import { selectors as commonSelectors } from '~/domains/common';
import AgentScannersView from './AgentScannersView';

/**
 * Maps Redux state to component props
 */
const mapStateToProps = (state) => ({
  scanConfigurations: agentScannersSelectors.scanners(state),
  isFetchingScanConfigurations:
    agentScannersSelectors.isFetchingScanners(state),
  organizationId: commonSelectors.organizationId(state),
  ownerId: commonSelectors.profile(state)?.id,
  context: commonSelectors.context(state)
});

/**
 * Maps Redux dispatch actions to component props
 */
const mapDispatchToProps = (dispatch) => ({
  openModal: ({ modalType, modalProps }) =>
    dispatch(modalActions.openModal({ modalType, modalProps })),
  onCreateScanner: (organizationId, scannerData) =>
    dispatch(
      agentScannersActions.createAgentScanner(organizationId, scannerData)
    ),
  onUpdateScanner: (organizationId, scannerId, scannerData) =>
    dispatch(
      agentScannersActions.updateAgentScanner(
        organizationId,
        scannerId,
        scannerData
      )
    ),
  onLoadScanners: (organizationId) =>
    dispatch(agentScannersActions.loadAgentScanners(organizationId))
});

/**
 * Connected component with Redux state and actions
 * Uses custom RootStoreContext for store access
 */
export default connect(mapStateToProps, mapDispatchToProps, null, {
  context: RootStoreContext
})(AgentScannersView);
